import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import {Draw, Modify, Snap} from 'ol/interaction.js';
import {get} from 'ol/proj.js';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import {Circle as CircleStyle, Fill, Stroke, Style, Icon} from 'ol/style.js';
import {OSM, Vector as VectorSource} from 'ol/source.js';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer.js';
import Overlay from 'ol/Overlay.js';
import {Polygon, Point} from 'ol/geom.js';
import {getArea, getLength} from 'ol/sphere.js';
import {unByKey} from 'ol/Observable.js';
import {Control, defaults as defaultControls} from 'ol/control.js';
import Projection from 'ol/proj/Projection.js';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4.js';
import ImageWMS from 'ol/source/ImageWMS.js';
import ImageLayer from 'ol/layer/Image.js';
import XYZ from 'ol/source/XYZ.js';
import {createEmpty, extend} from 'ol/extent.js';
import LineString from 'ol/geom/LineString.js';
import {transform} from 'ol/proj';
import { intersects } from 'ol/extent.js';
import { FALSE } from 'ol/functions';

window.CircleStyle = CircleStyle;
window.Icon = Icon;
window.Style = Style;
window.Stroke = Stroke;
window.Fill = Fill;
window.VectorSource = VectorSource;
window.Feature = Feature;
window.Circle = Circle;
window.VectorLayer = VectorLayer;
window.GeoJSON = GeoJSON;
window.TileLayer = TileLayer;
window.OSM = OSM;
window.get = get;
window.Draw = Draw;
window.Modify = Modify;
window.Snap = Snap;
window.Overlay = Overlay;
window.Polygon = Polygon;
window.Point = Point;
window.LineString = LineString;
window.getLength = getLength;
window.getArea = getArea;
window.unByKey = unByKey;
window.Control = Control;
window.Projection = Projection;
window.proj4 = proj4;
window.ImageWMS = ImageWMS;
window.ImageLayer = ImageLayer;
window.XYZ = XYZ;
window.createEmpty = createEmpty;
window.extend = extend;
window.transform = transform;
window.intersects = intersects;

const image = new CircleStyle({
  radius: 10,
  fill: null,
  stroke: new Stroke({ color: 'red', width: 10 }),
});

const styles = {
  'Point': new Style({
    image: image,
  }),
  'LineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1,
    }),
  }),
  'MultiLineString': new Style({
    stroke: new Stroke({
      color: 'green',
      width: 1,
    }),
  }),
  'MultiPoint': new Style({
    image: image,
  }),
  'MultiPolygon': new Style({
    stroke: new Stroke({
      color: 'yellow',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(255, 255, 0, 0.1)',
    }),
  }),
  'Polygon': new Style({
    stroke: new Stroke({
      color: 'blue',
      lineDash: [4],
      width: 3,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  }),
  'GeometryCollection': new Style({
    stroke: new Stroke({
      color: 'magenta',
      width: 2,
    }),
    fill: new Fill({
      color: 'magenta',
    }),
    image: new CircleStyle({
      radius: 10,
      fill: null,
      stroke: new Stroke({
        color: 'magenta',
      }),
    }),
  }),
  'Circle': new Style({
    stroke: new Stroke({
      color: 'red',
      width: 2,
    }),
    fill: new Fill({
      color: 'rgba(255,0,0,0.2)',
    }),
  }),
};

const styleFunction = function (feature) {
  return styles[feature.getGeometry().getType()];
};

window.styleFunction = styleFunction

class PGSTControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'M';

    const element = document.createElement('div');
    element.className = 'pgst-ctrl-1 ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleMeasureType.bind(this), false);
  }

  handleMeasureType() {
    changeMeasureType();
  }
}

//https://epsg.io/4674
//https://epsg.io/?format=json&q=4674
/*
{"number_result":1,"results":[{"accuracy":"","area":"Latin America - Central America and South America - onshore and offshore. Brazil - onshore and offshore.","authority":"EPSG","bbox":[32.72,-122.19,-59.87,-25.28],"code":"4674","default_trans":0,"kind":"CRS-GEOGCRS","name":"SIRGAS 2000","proj4":"+proj=longlat +ellps=GRS80 +no_defs +type=crs","trans":[],"unit":"degree (supplier to define representation)","wkt":"GEOGCS[\"SIRGAS 2000\",DATUM[\"Sistema_de_Referencia_Geocentrico_para_las_AmericaS_2000\",SPHEROID[\"GRS 1980\",6378137,298.257222101,AUTHORITY[\"EPSG\",\"7019\"]],AUTHORITY[\"EPSG\",\"6674\"]],PRIMEM[\"Greenwich\",0,AUTHORITY[\"EPSG\",\"8901\"]],UNIT[\"degree\",0.0174532925199433,AUTHORITY[\"EPSG\",\"9122\"]],AUTHORITY[\"EPSG\",\"4674\"]]"}],"status":"ok"}
*/

const wkt = 'GEOGCS["SIRGAS 2000",DATUM["Sistema_de_Referencia_Geocentrico_para_las_AmericaS_2000",SPHEROID["GRS 1980",6378137,298.257222101,AUTHORITY["EPSG","7019"]],AUTHORITY["EPSG","6674"]],PRIMEM["Greenwich",0,AUTHORITY["EPSG","8901"]],UNIT["degree",0.0174532925199433,AUTHORITY["EPSG","9122"]],AUTHORITY["EPSG","4674"]]'
const bbox = [32.72,-122.19,-59.87,-25.28];
//let worldExtent = [bbox[1], bbox[2], bbox[3], bbox[0]];
//proj4.setWorldExtent(worldExtent);
proj4.defs('EPSG:4674', wkt);
register(proj4);

//var projection = "EPSG:4326"
//var projection = "EPSG:4674"

//console.log(projection);

//const center = proj.transform([139.692101, 35.689634], 'EPSG:4326', 'EPSG:3857');

/*
const layers = [
  new TileLayer({
    source: new OSM(),
  })
];


const layers = [
  new TileLayer({
    source: new XYZ({
      //url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      url: 'http://s2maps-tiles.eu/wmts/1.0.0/s2cloudless-2021_3857/default/g/{z}/{y}/{x}.jpg'
    }),
  })
];*/

const layers = [
];

const info = document.getElementById('info');

const map = new Map({
  //controls: defaultControls().extend([new PGSTControl()]),
  controls: defaultControls({ zoom: false }),
  layers: layers,
  target: 'map',
  view: new View({
    center: [-65,-10],
    zoom: 4,
    maxZoom: 16,
    minZoom: 4,
    showFullExtent:false,
    projection: "EPSG:4674", //This is the correct, 4674
  }),
});
window.map = map;

let currentFeature = null;
let found = false;
let data = null;

map.on('pointermove', function (e) {
  //console.log("[---");
  found = false;
  const pixel = map.getEventPixel(e.originalEvent);
  map.forEachFeatureAtPixel(e.pixel, function (f,layer) {
    //console.log(f.ol_uid);
    if (layer instanceof VectorLayer) {
        if ( f != currentFeature ) {
          data = f.get("INFO")
          if ( data != undefined ) {
            info.style.left = pixel[0]+30 + 'px';
            info.style.top = pixel[1]+90 + 'px';
            info.style.visibility = 'visible';
            info.innerText = data;
          }
          currentFeature = f;
        } else {
          info.style.left = pixel[0]+30 + 'px';
          info.style.top = pixel[1]+90 + 'px';
        }

        found = true;
        return true;
    }
    return false;
  }); 
  //console.log("---]");
  if ( found == false && currentFeature != null && info != null) {
    currentFeature = null;
    info.style.visibility = 'hidden';
    //console.log("Nenhum");
  }
});

if ( map.getTargetElement() != null && info != null ) {
    map.getTargetElement().addEventListener('pointerleave', function () {
      currentFeature = null;
      info.style.visibility = 'hidden';
      //console.log("Saiu do Mapa");
    });
}
